// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"106":"92ee013b","632":"e436c3fa"}[chunkId] + ".chunk.css";
};